import useRoDetailModal from "../hooks/useRoDetailModal";
import RoDetailFullscreenDialog from "./RoDetailFullscreenDialog";

const RoDetailModalHost = () => {
  const {
    isOpen,
    isClosePending,
    closeRoDetail,
  } = useRoDetailModal();

  return (
    <RoDetailFullscreenDialog
      open={isOpen}
      onClose={closeRoDetail}
      isClosePending={isClosePending}
    />
  );
};

export default RoDetailModalHost;
